import ErrorCaster from "./utilities/errors/ErrorCaster";
import MessageException from "./utilities/errors/MessageException";

const messageExceptionCaster = new ErrorCaster<MessageException, void>(
  (e) => e instanceof MessageException,
  () => new MessageException("Une erreur est survenue", null),
);

export default messageExceptionCaster;
